import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const TupleRelationalCalculus = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Query: Tuple Relational calculus"
    videos={[
      "https://www.youtube.com/embed/SnsrohgiPo0"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default TupleRelationalCalculus;
